import * as THREE from 'three';

/**
 * Renderer.js - wraps THREE.WebGLRenderer setup.
 */
export class Renderer {
  constructor() {
    this.three = new THREE.WebGLRenderer({
      antialias: true,
      powerPreference: 'high-performance',
      alpha: false,
    });
    this.three.setSize(window.innerWidth, window.innerHeight);
    this.three.setPixelRatio(Math.min(window.devicePixelRatio, 2));
    this.three.outputColorSpace = THREE.SRGBColorSpace;
    document.body.appendChild(this.three.domElement);
  }

  render(scene, camera) {
    this.three.render(scene, camera);
  }

  setSize(w, h) {
    this.three.setSize(w, h);
  }
}
